import React, { useState } from "react";
import RoleToggle from "../../components/RoleToggle";
import ZoneListTab from "./_components/ZoneListTab";
import TireListTab from "./_components/TireListTab";

const ZoneManagement: React.FC = () => {
  const [activeRole, setActiveRole] = useState("Zone");
  const roles = ["Zone", "Tire"];
  return (
    <>
      <div className="p-4 space-y-4">
        <h1 className="text-3xl text-[#212121] ">Zone Management</h1>
        <RoleToggle
          options={roles}
          active={activeRole}
          onChange={setActiveRole}
        />
        {activeRole === "Zone" && <ZoneListTab />}
        {activeRole === "Tire" && <TireListTab />}
      </div>
    </>
  );
};

export default ZoneManagement;
